import React from 'react';

const PrevButton = ({ size = '20px', color = 'white' }) => (
    <svg 
        width={size} 
        height={size} 
        viewBox="0 0 20 20" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg">
        <path 
            fill-rule="evenodd" 
            clip-rule="evenodd" 
            d="M7.293 14.707C7.10553 14.5195 7.00021 14.2652 7.00021 14C7.00021 13.7349 7.10553 13.4806 7.293 13.293L10.586 10L7.293 6.70704C7.11084 6.51844 7.01005 6.26584 7.01233 6.00364C7.0146 5.74144 7.11977 5.49063 7.30518 5.30522C7.49059 5.11981 7.7414 5.01465 8.0036 5.01237C8.2658 5.01009 8.5184 5.11088 8.707 5.29304L12.707 9.29304C12.8945 9.48057 12.9998 9.73488 12.9998 10C12.9998 10.2652 12.8945 10.5195 12.707 10.707L8.707 14.707C8.51947 14.8945 8.26516 14.9998 8 14.9998C7.73484 14.9998 7.48053 14.8945 7.293 14.707Z" 
            fill={color}
        />
    </svg>
);

export default PrevButton;
